import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/node/app/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Button } from 'carbon-components-react';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const ImageCard = makeShortcode("ImageCard");
const Caption = makeShortcode("Caption");
const ResourceCard = makeShortcode("ResourceCard");
const ImageGallery = makeShortcode("ImageGallery");
const ImageGalleryImage = makeShortcode("ImageGalleryImage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Whether it’s sharing what I’ve learned about the craft or diving deep into the mental health hazards of our creative path, I love helping fellow writers.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Articles on Writing</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Mental Health for Writers</AnchorLink>
    </AnchorLinks>
    <h2>{`Articles on Writing`}</h2>
    <Row mdxType="Row">
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard title="Warning! New Writers Get This Secret Exactly Wrong..." href="https://billalive.com/warning-new-writers-get-this-secret-exactly-wrong/" actionIcon="launch" mdxType="ArticleCard">
          <img {...{
            "src": "https://picsum.photos/id/563/1200/600",
            "alt": "MicroMasters"
          }}></img>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard title="This Secret Extra Plotting Step Seriously Changes Everything..." href="https://billalive.com/secret-extra-plotting-step-seriously-changes-everything/" actionIcon="launch" mdxType="ArticleCard">
          <img {...{
            "src": "https://picsum.photos/id/486/1200/600",
            "alt": "MicroMasters"
          }}></img>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard title="How to Make Murder Funny (Or Not)" href="https://billalive.com/how-to-make-murder-funny-or-not-part-1/" actionIcon="launch" mdxType="ArticleCard">
          <img {...{
            "src": "https://picsum.photos/id/545/1200/600",
            "alt": "MicroMasters"
          }}></img>
        </ArticleCard>
  </Column>
    </Row>
    <h2>{`Mental Health for Writers`}</h2>
    <p>{`We writers live and work in a unique convergence of terrible conditions optimized to make us miserable. What can we do about? Let’s find out.`}</p>
    <h3>{`Website: Your Writing Is Killing You`}</h3>
    <Row mdxType="Row">
  <Column colMd={10} colLg={10} mdxType="Column">
        <ImageCard hoverColor="dark" titleColor="light" subTitleColor="light" iconColor="light" actionIcon="launch" aspectRatio="2:1" href="https://yourwritingiskillingyou.com" mdxType="ImageCard">
          <p><span parentName="p" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "50%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAACUElEQVQozwXBbVPSAAAA4F3qYLIXNgaDzW2MsU3eGY7BMDc7QMU3UMA3FA91JrPOo9Pu1DOvLq+UuuqD1vWp60f0+3oeAHaPIRAY8MKxMLNeqxjZeC4mTqeVQlzSJLaaj6+Z6u5cqb9V35ovzRdSeTk8yYb4AEF7MQCFQCFExFiqVS7dDk4HuytvT/Yu+t2jdq1azGoyb2bkaj65bhWr+aSZUdQoH6UDLOkNYijgGn1GeT2lhDSTlOzV8mmzcjVwbi4vBnbnqFkrxKKpMJMTJ4qT/JTEq9FwnGOEkI8msBCOABJDikFClfmGmdsoG/1u52l4/zT89OPu5tuHyzN7v728uNdqbK8ulA1dDJEi7ef9eBDHOB8CGDHOUCYUxq8r3JyWdtqN042Vv09ffw3f/364/Tn82GnWncPuomVIE0GO9HJ+nCYwHwrzJAJMsn4/4qaxcYFEyqlIs5S2l627s96Xm/O7q/Pvw88nhz17d6taVFOyIDJUAIXRcbcXhpQQCggUbqblnMRN8WQ9F9mbza1khOOqfnXcfXzj/Hndu3937eys16YSB636cbu+8FyPcrQf8yRoFECgsSU9fm1v9nfWFrLRAktkGVwTmf3K9ON27d+rzYfu0sv5ks5TGh/cmJ3uzJnNF0ZjRtOjFOBxjaIQqEuss71qL1qtJNMzlAMzaVvJk4pqW6lyhKzHOadmVTRV5UIZNkhjCEOgYRIBfB5XAHahkCuAuBkYTFGoQHiUAKaQiIyPJ3xwBIdp2K0KbCEmshiEQiACgRA44h4b+Q/2qIAC5Gqh1QAAAABJRU5ErkJggg==')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Your Writing Is Killing You",
                "title": "Your Writing Is Killing You",
                "src": "/static/fc407d580f136e1ab4bdf572474f56a8/3cbba/ywky-website.png",
                "srcSet": ["/static/fc407d580f136e1ab4bdf572474f56a8/7fc1e/ywky-website.png 288w", "/static/fc407d580f136e1ab4bdf572474f56a8/a5df1/ywky-website.png 576w", "/static/fc407d580f136e1ab4bdf572474f56a8/3cbba/ywky-website.png 1152w", "/static/fc407d580f136e1ab4bdf572474f56a8/595d0/ywky-website.png 1683w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy",
                "decoding": "async"
              }}></img>{`
    `}</span>{`]`}</p>
        </ImageCard>
        <Caption mdxType="Caption">
          <p>A fact-packed one-page site summarizing key research and techniques to help writers practice the mental hygiene we need.</p>
        </Caption>
      </Column>
    </Row>
    <h3>{`Interviews and Speaking`}</h3>
    <Row mdxType="Row">
      <Column colMd={8} colLg={8} mdxType="Column">
        <ul>
          <li parentName="ul">
            <p parentName="li">{`I gave an interview on “How Authors Work”, a podcast from `}<a parentName="p" {...{
                "href": "https://betabooks.co/"
              }}>{`BetaBooks`}</a></p>
          </li>
          <li parentName="ul">
            <p parentName="li">{`I gave a presentation at `}<strong parentName="p">{`Samuels Authorcon 2016`}</strong>{` (Front Royal, Virginia)`}</p>
          </li>
        </ul>
      </Column>
      <Column colMd={4} colLg={4} mdxType="Column">
  <ResourceCard subTitle="Presentation Handout" title="Your Writing Is Killing You" actionIcon="download" download="true" aspectRatio="4:3" href="/files/2016-Your_Writing_Is_Killing_You_Summary_Bill_Powell_Handout.pdf" mdxType="ResourceCard">
          <img {...{
            "src": "/be3e549bb1670c81eda0c91f81880c87/pdf.svg",
            "alt": "PDF"
          }}></img>
  </ResourceCard>
      </Column>
    </Row>
    <h3>{`Book: Your Writing Is Killing You `}<em>{`(Forthcoming)`}</em></h3>
    <Row mdxType="Row">
  <Column colMd={8} colLg={8} mdxType="Column">
        <p>{`It’s not just you, fellow writer.`}</p>
        <p>{`There’s solid evidence that the writing process itself is hazardous to your mental health.`}</p>
        <p>{`I don’t just mean it’s difficult, or draining, or that you face the Resistance that Pressfield tackles in the `}<em parentName="p">{`War of Art`}</em>{`. All true, but it gets worse: the `}<strong parentName="p">{`precise mental habits you must cultivate as a writer`}</strong>{`, especially to tell strong stories, can also make you `}<strong parentName="p">{`miserable`}</strong>{`.`}</p>
        <p>{`How do I know? Because with very few exceptions, they’re the exact mental habits that the `}<strong parentName="p">{`professionals implore us to reverse`}</strong>{`.`}</p>
        <p>{`We’ll start with the obvious: `}<strong parentName="p">{`isolation.`}</strong>{` You may already have noticed this one. “Oh, weird … writers tend to be depressed, and being alone makes you more depressed, but writers HAVE to spend hours and hours and hours all by themselves or they’ll never get anything written. Huh.”`}</p>
        <p>{`But isolation’s only the beginning.`}</p>
        <p>{`There are at least `}<strong parentName="p">{`four more major mental habits`}</strong>{` that are both `}<strong parentName="p">{`core to strong stories`}</strong>{` and `}<strong parentName="p">{`corrosive to good lives`}</strong>{`.`}</p>
        <p>{`In this book, we’ll explore these unique challenges that no one seems to talk about… and what we can do to both keep writing and start living.`}</p>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm noGutterMd noGutterLg noGutterXl mdxType="Column">
        <ImageGallery mdxType="ImageGallery">
          <ImageGalleryImage alt="Your Writing Is Killing You" title="Your Writing Is Killing You" mdxType="ImageGalleryImage">
            <span {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "518px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "154.16666666666666%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,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')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "ywky green",
                "title": "ywky green",
                "src": "/static/622a4699e28d504182a7a41b4e9eddae/d7f6f/ywky-green.png",
                "srcSet": ["/static/622a4699e28d504182a7a41b4e9eddae/7fc1e/ywky-green.png 288w", "/static/622a4699e28d504182a7a41b4e9eddae/d7f6f/ywky-green.png 518w"],
                "sizes": "(max-width: 518px) 100vw, 518px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy",
                "decoding": "async"
              }}></img>{`
    `}</span>
          </ImageGalleryImage>
        </ImageGallery>
  </Column>
    </Row>
    <h3>{`Giving Back`}</h3>
    <p>{`My own writing life has been immeasurably improved by writing `}<a parentName="p" {...{
        "href": "/community/conferences"
      }}>{`conferences`}</a>{` and `}<a parentName="p" {...{
        "href": "/community/workshops"
      }}>{`workshops`}</a>{`, in multiple communities of welcoming writers. These resources are a small attempt to give something useful back.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      